import { UNAUTHORIZED_CONNECT_TOOLTIP } from '../../constants';
import WithAccountPermissions from './WithAccountPermissions';

const WithConnectOrgPermission = (props: any) => (
  <WithAccountPermissions
    permissionStr={['create:orgs']}
    disabledTooltip={UNAUTHORIZED_CONNECT_TOOLTIP}
    {...props}
  />
);

export default WithConnectOrgPermission;
